import { useState, useEffect } from "react";
import { Modal, Descriptions, Tag, Typography, Form, Input } from "antd";
import { getReportById, replyReport } from "../../constants/API/API";
import { ShowToast, Severty } from "../../helper/toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import callApi from "../../constants/API/CallApi";

const { Title } = Typography;

const isImage = (url) => /\.(jpeg|jpg|gif|png|webp|bmp)$/i.test(url);
const isVideo = (url) => /\.(mp4|webm|ogg|mov)$/i.test(url);

export const ReportView = ({ viewVisible, setViewVisible, selectedReport }) => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedReport) {
      setLoading(true);
      getReportById(selectedReport)
        .then((response) => {
          if (response.status === 200 && response.data) {
            setReportData(response.data);
          }
        })
        .catch((err) => {
          ShowToast(
            err.message || "Failed to fetch report data",
            Severty.ERROR
          );
        })
        .finally(() => setLoading(false));
    }
  }, [selectedReport]);

  const handleCancel = () => {
    setViewVisible(false);
    setReportData(null);
  };

  return (
    <Modal
      open={viewVisible}
      title={
        <Title level={4} style={{ margin: 0 }}>
          Report Details
        </Title>
      }
      onCancel={handleCancel}
      footer={null}
      width={700}
      destroyOnClose
      loading={loading}
    >
      {reportData && (
        <Descriptions
          bordered
          column={1}
          labelStyle={{
            fontWeight: 500,
            backgroundColor: "#fafafa",
            minWidth: "150px",
          }}
          contentStyle={{
            backgroundColor: "#fff",
          }}
        >
          <Descriptions.Item label="Report ID">
            <Tag style={{ fontFamily: "monospace" }}>{reportData.issueId}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="User Name">
            {reportData.userId?.name || reportData.studentName || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Branch">
            {reportData.branchId?.name || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Subject">
            {reportData.subject || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Description">
            {reportData.description || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag
              color={
                reportData.status === "open"
                  ? "blue"
                  : reportData.status === "in-progress"
                    ? "orange"
                    : reportData.status === "resolved"
                      ? "green"
                      : "red"
              }
            >
              {reportData.status?.replace("-", " ").toUpperCase()}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Reply">
            {reportData.reply || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Active">
            <Tag color={reportData.isActive ? "success" : "error"}>
              {reportData.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
          {/* <Descriptions.Item label="Attachments">
            {Array.isArray(reportData.attachments) &&
            reportData.attachments.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                {reportData.attachments.map((url, idx) =>
                  isImage(url) ? (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={idx}
                    >
                      <img
                        src={url}
                        alt={`attachment-${idx}`}
                        style={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 4,
                          border: "1px solid #eee",
                        }}
                      />
                    </a>
                  ) : isVideo(url) ? (
                    <video
                      key={idx}
                      src={url}
                      controls
                      style={{
                        width: 120,
                        height: 80,
                        borderRadius: 4,
                        border: "1px solid #eee",
                      }}
                    />
                  ) : (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={idx}
                    >
                      {url}
                    </a>
                  )
                )}
              </div>
            ) : (
              "-"
            )}
          </Descriptions.Item> */}
        </Descriptions>
      )}
    </Modal>
  );
};

export const ReportReply = ({ setReplyModal, replyModal, report, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");

  const handleOk = async (values) => {
    setLoading(true);
    // debugger;
    callApi({
      callback: replyReport,
      payload: [{ ...values, reportId: report }],
      onSuccess: ({ message }) => {
        refresh(new Date().getTime());
        ShowToast(message, Severty.SUCCESS);
        setReplyModal(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setReplyModal(false);
  };

  return (
    <Modal
      className="tab_modal"
      title="Update Email"
      open={replyModal}
      okButtonProps={{
        htmlType: "submit",
        form: "edit-email",
        loading: loading,
      }}
      onCancel={handleCancel}
      afterClose={() => form.resetFields()}
    >
      <Form
        id="edit-email"
        onFinish={handleOk}
        form={form}
        layout="vertical"
        initialValues={report}
      >
        <Form.Item
          name="subject"
          label="Email Subject"
          rules={[{ required: true, message: "Please enter the subject" }]}
        >
          <Input placeholder="Enter subject" />
        </Form.Item>
        <Form.Item
          label="Email Description"
          name="description"
          className="short try col-12"
          style={{ marginTop: "10px" }}
        >
          <ReactQuill
            placeholder="Enter email description here..."
            value={description}
            onChange={setDescription}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["clean"],
              ],
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
